import styles from "./EditorsNote.module.scss";
import { EditorsNoteFragment } from "types/api";
import gql from "graphql-tag";

const EditorsNote = ({ content }: EditorsNoteFragment) => {
  return (
    // section id is needed for linking within the article
    <section className={styles.editorsNote} id="editors-note">
      {content.length > 0 && (
        <p className={styles.content}>
          <span className={styles.label}>Editor&rsquo;s Note: </span>
          <span dangerouslySetInnerHTML={{ __html: content }} />
        </p>
      )}
    </section>
  );
};

EditorsNote.fragment = gql`
  fragment editorsNote on EditorsNote {
    content
  }
`;

export default EditorsNote;
